import React from "react";
import { SystemViewContext } from "./system-view-context";
import { usePageSystemViewHook } from "./system-view-hooks";

export function ContextSystemViewProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const value = usePageSystemViewHook();

  return (
    <SystemViewContext.Provider value={value}>
      {children}
    </SystemViewContext.Provider>
  );
}
